import React, { useReducer, useEffect,useState } from 'react';
import DocumentInput from '../../../../components/DocumentInput/DocumentInput';
import { documentList } from '../../../../data/documentList';
import { DocumentsContext, initialState, reducer } from '../../../../reducers/documents_reducers';
import axios from 'axios';

import 'react-notifications/lib/notifications.css';
import { NotificationContainer , NotificationManager} from 'react-notifications';
// import createNotification from '../notifications/fileupload_notification';

const ClientDocs = (props) => {
  const [ state, dispatch ] = useReducer(reducer, initialState);
  const [ data, setData ] = useState([])
  const [ verified, setVerified ] = useState({v: false})
  
  let createNotification = (type, doc="") => {
    return () => {
      switch (type) {
        case 'info':
          NotificationManager.info('Info message');
          break;
        case 'success':
          NotificationManager.success(`${doc}`, 'Reporte enviado con éxito');
          break;
        case 'warning':
          NotificationManager.warning(`${doc} no coincide con el nombre de este campo`, 'Cuidado', 3000);
          break;
          case 'warning-no-document':
            NotificationManager.warning(`No has seleccionado documento`, 'Cuidado', 3000);
            break;
        case 'error':
          NotificationManager.error('Error message', 'Click me!', 5000, () => {
            alert('callback');
          });
          break;
        default: break;
      }
    };
  };
  
  let docExistence = () => 
    documentList.map((documentName, index) => {
    let existence = data ? data.filter(doc => doc.name === documentName) : []
      let documentUploaded = (
        <DocumentInput color="#00B8B2"  key={index} name={documentName} userId={props.match.params.id} createNotification={createNotification} />
      );
      let documentNotUploaded = (
        <DocumentInput color="#E80843"  key={index} name={documentName} userId={props.match.params.id} createNotification={createNotification} />
      );
      return  existence.length > 0 ? documentUploaded : documentNotUploaded
      
    })

  useEffect(() => {
    docExistence()
    createNotification()
    let config =  { 
      headers: {
        'Authorization': "bearer " + JSON.parse(localStorage.getItem('token'))
      }
    };

    axios.get(
      // `http://localhost:3000/data/get_data/${props.match.params.id}`,
      `https://blooming-spire-64013.herokuapp.com/data/get_data/${props.match.params.id}`,
      config,
      { withCredentials: true })
      .then(response => {
        setData(response.data)
        setVerified(!verified.v)
      })
      .catch(err => {
        alert("¡Usuario no autorizado!");
      })
  }, [verified.v])
  
  return (
    <DocumentsContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <NotificationContainer />
      <div style={{display: "flex", flexWrap: "wrap", justifyContent: "center",alignItems: "center", marginTop: "120px"}}>
        {
          docExistence()
        }
      </div>
    </DocumentsContext.Provider>
  );
};

export default ClientDocs;
